import React from "react";
import Header from "../components/Header";
import Slider from "../components/Slider";
import Footer from "../components/Footer";
import HomeBanner from "../components/HomeBanner";
import SplitBanner from "../components/SplitBanner";
import InstaVideo from "../components/InstaVideo";
import SectionBanner from "../components/SectionBanner";
import TopSellingReturnGifts from "../components/TopSellingReturnGifts";
import  Instagram  from "../components/InstagramFeeds";

const Home = () => {
    return (

        <>
            <Header />
            <SectionBanner/>
            {/* <HomeBanner /> */}
            <TopSellingReturnGifts />
            <SplitBanner />
            <Slider />
            <InstaVideo />
            <Instagram/>
            <Footer />
        </>
    )
}
export default Home; 